import { Subject } from "rxjs";
import { log2 } from "./log2";

const messages = new Subject();
const log = log2("PUB_SUB");

export const publishMessage = (type, payload) => {
    log("publishMessage", { type, payload });
    messages.next({
        type,
        payload,
    });
};

export const systemMessageStream = messages.asObservable();

export const SystemMessageTypes = {
    TAB_VISIBILITY_CHANGE: "tab_visibility_change",
    PERSONAL_DATA_DELETED: "personal_data_deleted",
    RESTART_NEEDED: "RESTART_NEEDED",
    SET_STEP: "SET_STEP",
    AUTO_LOGIN: "AUTO_LOGIN",
    CLOSE_CHAT: "CLOSE_CHAT",
    SEND_LOGIN: "SEND_LOGIN",
    VISITOR_ID_RECEIVED: "VISITOR_ID_RECEIVED",
};

document.addEventListener("visibilitychange", () => {
    publishMessage(SystemMessageTypes.TAB_VISIBILITY_CHANGE, {
        visible: document.visibilityState === "visible",
    });
});

const EVENT_BUS = {
    publish: publishMessage,
    stream: systemMessageStream,
    MessageTypes: SystemMessageTypes,
};

export default EVENT_BUS;



// WEBPACK FOOTER //
// ./src/utils/systemPubSub.js